import { connect } from 'react-redux';
import Player from '../components/player';

import { removeRelatedThumbnail } from '../actions/media';
import { setPlayerLoaded, seek } from '../actions/player';
import { showScrubber, goToComment } from '../actions/ui';

const mapStateToProps = function(state) {
	return {
		comments: state.comments,
		player: state.player,
		iframe: state.ui.iframe,
		show_scrubber: state.ui.show_scrubber,
		duration: state.player.duration,
		position: state.player.position,
		next: state.media.related && state.media.related.next ? state.media.related.next : null,
		previous: state.media.related && state.media.related.previous ? state.media.related.previous : null,
		allow_chart: state.features.chart && state.player.duration !== 0,
		show_media: state.features.media
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		showScrubber: (visible)=>dispatch(showScrubber(visible)),
		setPlayerLoaded: (player)=>dispatch(setPlayerLoaded(player)),
		goToComment: (objectid)=>dispatch(goToComment(objectid)),
		seek: (timestamp)=>dispatch(seek(timestamp)),
		removeRelatedThumbnail: (index)=>dispatch(removeRelatedThumbnail(index))
	};
}

const PlayerContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Player);

export default PlayerContainer;